import { useSettingsContext } from "src/mtska-frontend-app-scaffolding"
import { DateRangeFilter } from "./customSelectionFilter/dateRangeFilter/DateRangeFilter"
import { NumericRangeFilter } from "./customSelectionFilter/numericRangeFilter/NumericRangeFilter"
import { SelectOptionsFilter } from "./customSelectionFilter/selectOptionsFilter/SelectOptionsFilter"
import { dataProviderReducer } from "src/mtska-frontend-data-provider/redux/reducer"
import { Cell } from "../ListElements"
import { pick } from 'dot-object'

export const getCustomFilterOperators = ({ options, t, type, value }) => {
    const isDataRange = ['date', 'datetime'].includes(type)
    const isNumericRange = type === 'currency'

    const operator = isDataRange || isNumericRange ? 'between' : 'equals'

    return {
        InputComponent: (params) => {
            if (isDataRange) {
                return <DateRangeFilter {...params} value={value} />
            } else if (isNumericRange) {
                return <NumericRangeFilter {...params} value={value} />
            } else if (options) {
                return <SelectOptionsFilter {...params} options={options} value={value} />
            }
        },
        label: t('Select Filter'),
        value: operator
    }
}

export const getCustomLocaleText = ({ t }) => {
    return {
        headerFilterOperatorBetween: t('Between'),
        headerFilterOperatorContains: t('Contains'),
        headerFilterOperatorDoesNotContain: t('Does not contain'),
        headerFilterOperatorEquals: t('Equals'),
        headerFilterOperatorDoesNotEqual: t('Does not equal'),
        headerFilterOperatorStartsWith: t('Starts with'),
        headerFilterOperatorEndsWith: t('Ends with'),
        headerFilterOperatorIs: t('Is'),
        headerFilterOperatorNot: t('Is not'),
        headerFilterOperatorIsNot: t('Is not'),
        headerFilterOperatorAfter: t('Is after'),
        headerFilterOperatorOnOrAfter: t('Is on or after'),
        headerFilterOperatorAfterOrNull: t('After or null'),
        headerFilterOperatorBefore: t('Is before'),
        headerFilterOperatorOnOrBefore: t('Is on or before'),
        headerFilterOperatorBeforeOrNull: t('Before or null'),
        headerFilterOperatorIsEmpty: t('Is empty'),
        headerFilterOperatorIsNotEmpty: t('Is not empty'),
        headerFilterOperatorIsAnyOf: t('Is any of'),
        headerFilterOperatorSelectFilter: t('Select Filter'),
        headerFilterOperatorIn:t('In'),
        'headerFilterOperator=': t('Equals'),
        'headerFilterOperator!=': t('Not equals'),
        'headerFilterOperator>': t('Greater than'),
        'headerFilterOperator>=': t('Greater than or equal to'),
        'headerFilterOperator<': t('Less than'),
        'headerFilterOperator<=': t('Less than or equal to'),
    }
}

export const getFormattedRows = ({ items, tableConfig }) => {
    const { columnsRendered = {} } = tableConfig
    const formattedRows = (items || []).map((item = {}) => {
        const formattedItem = {}
        Object.keys(item).forEach((key) => {
            const { [key]: value } = item
            const type = columnsRendered[key]?.type
            if (type === 'date' || type === 'datetime') {
                formattedItem[key] = value ? new Date(value) : undefined
            } else {
                formattedItem[key] = value
            }
        })
        return formattedItem
    })
    return formattedRows
}

export const moveArrayElement = (array, fromIndex, toIndex) => {
    const element = array[fromIndex]
    array.splice(fromIndex, 1)
    array.splice(toIndex, 0, element)
    return array
}

export const handleApplyRecipe = (recipe, apiRef, setSettingsKey) => {
    if (!recipe) return;

    // NON PRENDERE DA QUI LE COLONNE; PRENDILE DA 
    // const { tableConfig } = config?.data?.modules[dataProviderName];
    const ac = apiRef.current.getAllColumns();

    const vm = Object.fromEntries(
        ac.map((c) => {
            if (recipe[c.field]) {
                return [c.field, true];
            }

            return [c.field, false];
        })
    );

    console.info('ListComponent:handleApplyRecipe chiamo setSettingsKey ', vm)
    setSettingsKey('visibilityModel', vm);
}

export const getColumnDefinition = (settings, config, dataProviderName, t) => {
    if (!settings || !config?.data?.modules[dataProviderName]?.tableConfig) return;

    const { tableConfig } = config?.data?.modules[dataProviderName];

    if (Array.isArray(tableConfig?.columns) && Object.keys(settings).length > 0) {

        const { filterModel, visibilityModel } = settings;
        const { items = [] } = filterModel || {}

        // if (items.length > 0) {
        //     const cleanFilterModel = cleanFilters(filterModel);
        //     managePotentiallyChangedFilters(cleanFilterModel, false);
        // }

        const columns = tableConfig.columns.map((field) => {
            const {
                fieldKey,
                options: valueOptions,
                optionsEditable = {},
                type: fieldType,
                typeEditable,
                hideable
            } = tableConfig.columnsRendered[field] || {}

            const {
                action,
                dataProviderName: optionsDataProviderName,
                filters,
                optionKey,
                optionLabel
            } = optionsEditable

            // campi filtri custom
            const value = items.find(item => item.field === field)?.value;
            const customFilters = {}
            if (valueOptions || [/* 'currency',  */'date', 'datetime'].includes(fieldType)) {
                customFilters.filterOperators = [getCustomFilterOperators({ options: valueOptions, t, type: fieldType, value })]
            }

            // campi celle custom
            const isCustomField = ['boolean'/* , 'currency' */, 'relationship'].includes(fieldType)
            const minWidth = ['date', 'datetime'].includes(fieldType) || ['relationship'].includes(typeEditable) ? 220 : 150
            const filterType = isCustomField
                ? undefined
                : valueOptions
                    ? 'singleSelect'
                    : fieldType === 'date' || fieldType === 'datetime'
                        ? fieldType
                        : fieldType === 'currency'
                            ? 'number'
                            : 'string'


            return {
                field,
                fieldKey,
                value,
                type: fieldType,
                typeEditable,

                options: valueOptions,
                action,
                dataProviderName: optionsDataProviderName,
                filters,
                optionKey,
                optionLabel,

                customFilters,
                isCustomField,
                hideable,
                filterType
            }
        })

        return columns
    }
}

export const getColumnRender = (settings, config, dataProviderName, t, detailStack, processRowUpdate) => {
    if (!settings || !config?.data?.modules[dataProviderName]?.tableConfig) return;

    const { tableConfig } = config?.data?.modules[dataProviderName];

    if (Array.isArray(tableConfig?.columns) && Object.keys(settings).length > 0) {

        const { filterModel, visibilityModel } = settings;
        const { items = [] } = filterModel || {}

        // if (items.length > 0) {
        //     const cleanFilterModel = cleanFilters(filterModel);
        //     managePotentiallyChangedFilters(cleanFilterModel, false);
        // }

        const columns = tableConfig.columns.map((field) => {
            const {
                editable,
                fieldKey,
                options: valueOptions,
                optionsEditable = {},
                type: fieldType,
                typeEditable
            } = tableConfig.columnsRendered[field] || {}

            const {
                action,
                dataProviderName: optionsDataProviderName,
                filters,
                optionKey,
                optionLabel
            } = optionsEditable

            // campi filtri custom
            const value = items.find(item => item.field === field)?.value;
            const customFilters = {}
            if (valueOptions || [/* 'currency',  */'date', 'datetime'].includes(fieldType)) {
                customFilters.filterOperators = [getCustomFilterOperators({ options: valueOptions, t, type: fieldType, value })]
            }

            // campi celle custom
            const isCustomField = ['boolean'/* , 'currency' */, 'relationship'].includes(fieldType)
            const minWidth = ['date', 'datetime'].includes(fieldType) || ['relationship'].includes(typeEditable) ? 220 : 150
            const filterType = isCustomField
                ? undefined
                : valueOptions
                    ? 'singleSelect'
                    : fieldType === 'date' || fieldType === 'datetime'
                        ? fieldType
                        : fieldType === 'currency'
                            ? 'number'
                            : 'string'

            return {
                editable: typeEditable ? false : editable,
                field,
                flex: 1,
                headerName: tableConfig.columnsRendered[field]?.label ?? t(field.replace("_readable", "")
                    .replace("_calculated_", "")
                    .replace("_related_", "")
                    .replace("_related.", "")),
                hideable: visibilityModel === false || tableConfig.columnsRendered[field]?.hideable === false ? false : true,
                filterable: tableConfig.columnsRendered[field]?.filterable === false ? false : true,
                sortable: tableConfig.columnsRendered[field]?.sortable === false ? false : true,
                minWidth: tableConfig.columnsRendered[field]?.minWidth ? tableConfig.columnsRendered[field]?.minWidth : minWidth,
                renderCell: (params) => {
                    const columnRendered = tableConfig.columnsRendered[params?.field]
                    const drawerRoute = tableConfig.columnsRendered[params?.field]?.drawerRoute
                    const fieldDataProviderName = tableConfig.columnsRendered[params?.field]?.providerName;
                    const val = typeof params?.row === 'object' ? pick(field, params.row) : params.value?.value;
                    return (
                        <Cell
                            action={action}
                            columnRendered={columnRendered}
                            configFilters={filters}
                            fieldKey={fieldKey}
                            dataProviderName={dataProviderName}
                            detailStack={detailStack}
                            drawerRoute={drawerRoute}
                            field={params?.field}
                            fieldDataProviderName={fieldDataProviderName}
                            filters={filters}
                            optionKey={optionKey}
                            optionLabel={optionLabel}
                            optionsDataProviderName={optionsDataProviderName}
                            processRowUpdate={processRowUpdate}
                            row={params.row}
                            type={columnRendered?.type}
                            typeEditable={typeEditable}
                            value={val}
                            valueOptions={valueOptions}
                        />
                    )
                },
                type: filterType,
                valueOptions,
                ...customFilters
            }
        })
        return columns
    }
}